.aha-comment-link {
  display: flex;
  align-items: center;
  gap: var(--spacer-1);
}

.aha-comment-link__line {
  color: var(--theme-tertiary-text);
}
